import { LinkBox as ChakraLinkBox } from '@chakra-ui/react';

export const LinkBox = ChakraLinkBox;
